/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from "react";
import env from '../env';
import Axios from 'axios'
import { getItem } from '../../common/utils/StorageManager';
//const axios = require('axios');




const getRequestOption = (endPoint, urlParams, token) => {

    let url = env.API_DOMAIN + endPoint + '/' + env.API_ORGANIZATOIN + '/' + env.PRODUCT_MODEL_REGION + '/' + urlParams;

    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'apiKey': env.API_KEY,

        // 'Strict-Transport-Security':'max-age=31536000',
        // 'X-Frame-Options': 'SAMEORIGIN',
        // 'X-DNS-Prefetch-Control': 'on',
        // 'X-Content-Type-Options': 'nosniff',
        // 'X-XSS-Protection': '1',
        // 'X-Download-Options': 'noopen',
        //  'Content-Security-Policy': 'self'

    };
    let edwData = getItem('edwData');
    if (edwData && edwData.edwSId != null && edwData.edwUId != null){
        headers['impersonateOrgId'] = edwData.edwSId;
        headers['impersonateUserId'] = edwData.edwUId;
    }
   
    let option = {
        method: 'get',
        url: url,
        data: null,
        headers: headers,
        timeout: 10000,
        responseType: 'json'
    }

    return option;

}


const asyncCallHandler = (endPoint, urlParams, token, method = 'get', data = '') => {
    let option = getRequestOption(endPoint, urlParams, token);
    option.method = method;
    option.data = (data != '') ? data:null;
    return Axios(option);
}

export default asyncCallHandler;
